import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageDocsContent from './PageDocsContent';

function PageDocs(props) {
    const { layout } = props;
    let content;
    if (layout === 'classic') {
        content = (
            <PageDocsContent layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <PageDocsContent layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

PageDocs.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

PageDocs.defaultProps = {
    layout: 'classic',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(PageDocs);
